<template>
  <li
    :class="rootClassName"
    @click="handleClick">
    <slot />
  </li>
</template>

<script>

export default {
  name: 'Tab',

  props: {
    value: {
      type: [ Number, String ],
      required: true
    }
  },

  inject: [ 'Tabs' ],

  methods: {
    handleClick () {
      this.Tabs.handleChange(this.value)
    }
  },

  computed: {
    active () {
      return this.Tabs.value === this.value
    },

    rootClassName () {
      return [
        this.$style.root,
        this.$style[this.Tabs.size],
        this.$style[this.Tabs.variant],
        { [ this.$style.active ]: this.active }
      ]
    }
  }
}

</script>

<style module>

.root {
	
	@apply
    px-4
		text-center
		cursor-pointer
		text-dull-dark
		font-medium;
}

.small {
  @apply
    py-2
    text-sm;
}

.medium {
  @apply
    py-4
    text-base;
}

.underlined, 
.divided {
	@apply
		relative
		border-b
		border-solid
		border-transparent;
}

.underlined.active,
.divided.active {
	@apply
		text-primary;
}

.underlined.active::after,
.divided.active::after {
	content: '';
  position: absolute;
  z-index: 1;
  left: 0;
  bottom: -2px;
  width: calc(100% + 1px);
	@apply
		text-primary
		border-b
		border-solid
		border-primary;
}

.underlined:last-child.active::after,
.divided:last-child.active::after {
  width: 100%;
}

.divided {
  box-sizing: content-box;
	@apply
		border-b
		border-solid
		border-dull;
}

.divided:not(:last-child) {
  margin-right: -1px;
  @apply
		border-r
		border-solid
		border-dull;
}

.dividing {
	@apply
		border
		border-solid
		border-transparent
		border-b
		border-solid
		border-dull;
}

.dividing.active {
  border-bottom: none;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  margin-left: -1px;
	margin-right: -1px;
	@apply
		text-primary
		border
		border-solid
		border-dull;
}

</style>
